import { Component, OnInit } from '@angular/core';
import { GeneralService } from "../services/general.service";
import { ActivatedRoute } from '@angular/router';
declare var $ :any
@Component({
  selector: 'app-avt-interlocuteur',
  templateUrl: './avt-interlocuteur.component.html',
  styleUrls: ['./avt-interlocuteur.component.scss']
})
export class AvtInterlocuteurComponent implements OnInit
{
  constructor(public route: ActivatedRoute,public generalService:GeneralService) { }
  
  // interlocuteur =  {TiersC_Id:"",TiersC_Civilite:"",Tiers_code:"",TiersC_Nom:"",TiersC_PreNom:"",TiersC_Service:"",TiersC_Fonction:"",TiersC_Mail:"",TiersC_Tel:"",TiersC_Mobile:""}
  interlocuteur;
  interlocuteurInit;
  exist : boolean = true;
  dsabledBtnEnregister : boolean = false;
  civilites = [{text:"Monsieur",value:0},{text:"Madame",value:1}];
  disabled :boolean = false;
  data = {TiersC_Id:"",Tiers_code:""}
  ngOnInit() 
  {
    this.interlocuteur = {};
    this.readParamUrl();
  }
  getInterlocuteur()
  {
    if(this.data.TiersC_Id == "-1")
      var url = this.generalService.urlInterlocuteur;
    else
      var url = this.generalService.urlInterlocuteur+'&val='+this.data.TiersC_Id;
    this.generalService.rechercheTable(url).subscribe(rec =>
    {
      this.interlocuteurInit = rec;
      this.interlocuteur = this.interlocuteurInit.TiersC[0];
    })
  }
  
  removeNumberFromText(text:string,attribut:string)
  {
    setTimeout( () => 
    {
      var myText = this.generalService.removeNumberFromText(text);
      var interlocuteur = this.interlocuteur;
      eval("interlocuteur."+attribut+" = myText");
    },1);
  }
  enregistrer(f)
  {
    if (f.form.valid) 
    {
      this.exist = false;
      this.dsabledBtnEnregister = true;
      this.interlocuteur.Tiers_code = this.data.Tiers_code;
      this.generalService.enregisterTable(this.interlocuteurInit).subscribe(interlocuteur =>
      {    
        if(interlocuteur.code != "" && interlocuteur.code != null && interlocuteur.code != undefined)    
          this.interlocuteur.TiersC_Id = interlocuteur.code;
          localStorage.setItem("interlocuteur",JSON.stringify({status:true,interlocuteur:this.interlocuteur}))
          window.close()
      },
      (error)=>
      {
        // this.dialogRef.close({status:false});
      })
    }
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.data.TiersC_Id = params['TiersC_Id'];
      this.data.Tiers_code = params['Tiers_code'];
      this.getInterlocuteur();
    })
  }
}
